import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../../shared/lib/messages";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      defaultError: formatMessage(commonMessages.defaultError),
      firstTitle: formatMessage(messages.firstTitle),
      secondTitle: formatMessage(messages.secondTitle),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
